<template>
	<div>
		<Bar v-bind:authService="authService"></Bar>
		<router-view />
	</div>
</template>

<script>
import Bar from "./component/Bar.vue";

export default {
	props: {
		authService: {
			type: Object,
		},
	},
	components: {
		Bar,
	},
	created() {
		this.$i18n.locale = 'pt';
	}
};
</script>

<style>
h3 {
	margin: 0px !important;
}
.btn:not(:last-child) {
    margin-right: 10px;
}
.padding-lg {
	padding: 60px;
}
.padding-md {
	padding: 30px;
}
</style>
